// Central API integration for both BlueSettle lead forms.
// Configure REACT_APP_LEADS_API_URL in frontend/.env.production (or Cloudflare Pages env).
const API = process.env.REACT_APP_LEADS_API_URL || "";

export async function submitLead(formData) {
  if (!API) throw new Error("The lead form is not configured yet. Please contact info@bluesettle.com.");
  const file = formData.get("bill");
  if (file && file.size) {
    if (file.size > 20 * 1024 * 1024 || !["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
      throw new Error("Please upload a PDF, JPG, or PNG smaller than 20 MB.");
    }
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  try {
    const res = await fetch(API.replace(/\/$/, "") + "/submit", {
      method: "POST", body: formData, signal: controller.signal,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.ok) throw new Error(json.error || "We couldn't submit your request. Please try again.");
    return json;
  } catch (err) {
    if (err.name === "AbortError") throw new Error("The request timed out. Please check before resubmitting.");
    throw err;
  } finally { clearTimeout(timeout); }
}
